<template>
  <div id="wrap">
    <!-- banner区域 -->
    <div class="banner">
      <div class="bannerText">
        <div>手机行业解决方案</div>
        <div>依靠科技创新，优化产品体验，</div>
        <div> 带给大众安全普惠的手机服务解决方案</div>
      </div>
    </div>
    <!-- 中间内容区域 -->
    <div class="wrap">
      <!-- 用于绝对/固定定位 -->
      <div class="nav-wrap">
        <!-- 用于相对定位 -->
        <div class="nav-wrap-inner">
          <!-- 左边导航 -->
          <div class="nav">
            <div :class="{'active':$route.path.indexOf('/solution/service')!==-1}">
              <router-link to="/solution/service">个人3C服务</router-link>
            </div>
            <div :class="{'active':$route.path.indexOf('/solution/bsolution')!==-1}">
              <router-link to="/solution/bsolution">B端行业解决方案</router-link>
            </div>
            <div :class="{'active':$route.path.indexOf('/solution/supplychain')!==-1}">
              <router-link to="/solution/supplychain">供应链解决方案</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边内容 -->
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 是否显示导航菜单
      isShowNav: false
    };
  },
  methods: {
    // 展示nav
    showNav() {
      this.isShowNav = true;
    },
    closeNave() {
      this.isShowNav = false;
    },
    // 页面加载，给页面添加滚动事件
    showNavScroll() {
      document.onscroll = () => {
        let wrap = document.querySelector(".wrap");
        let navWrap = document.querySelector(".nav-wrap");
        let wrapTop = wrap.getBoundingClientRect().top;
        let wrapBottom = wrap.getBoundingClientRect().bottom;
        let fixed = navWrap.className.split(/\s+/)[1];
        if (wrapTop < 0 && !fixed && wrapBottom > 343) {
          navWrap.classList.add("fixed");
        } else if (wrapTop > 0 && fixed) {
          navWrap.classList.remove("fixed");
        }
        if (wrapBottom < 343 && fixed) {
          navWrap.classList.remove("fixed");
        }
      };
    }
  },
  mounted() {
    // 绑定事件
    this.$bus.$on("showNav", this.showNav);

    // 加载组件后，绑定滚动事件
    this.showNavScroll();
  },
  updated() {
    console.log("是否展示nav", this.isShowNav);
  },
   destroyed(){
    this.$bus.$emit('closeNave')
  }
};
</script>

<style  lang="scss" scoped>
#wrap {
  .banner {
    background-image: url("https://p3.ssl.qhimg.com/t01449c6f612e0cdf91.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 425px;
    position: relative;
    .bannerText {
      color: white;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      div:nth-child(1) {
        font-size: 50px;
        font-weight: 300;
        margin-bottom: 38px;
      }
      div:nth-child(2),
      div:nth-child(3) {
        font-size: 18px;
        font-weight: 400;
        text-align: center;
      }
      div:nth-child(2) {
        margin-bottom: 20px;
      }
    }
    // nav
    .nav {
      width: 1032px;
      height: 387px;
      background-color: #f9faff;
      margin: 0 auto;
      padding: 47px 30px 12px 60px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      z-index: 2;
      li {
        width: 207px;
        height: 134px;
        background-color: #fff;
        position: relative;
        margin-right: 28px;
        margin-bottom: 30px;
        .icon {
          width: 31px;
          height: 31px;
          background-image: url("../../assets/imgs/product/jdicon.png");
          background-repeat: no-repeat;
          background-size: 100%;
          position: absolute;
          left: 34px;
          top: 32px;
        }
        .content {
          width: 102px;
          transform: translate(80px, 35px);
          div:nth-child(1) {
            margin-bottom: 18px;
            font-size: 16px;
            color: #000;
            font-weight: 600;
          }
          div:nth-child(2) {
            color: #999999;
            font-size: 14px;
            font-weight: 600;
            line-height: 21px;
          }
        }
      }
    }
  }
  .wrap {
    position: relative;
    margin: 0 auto;
    padding: 0 0 0 118px;
    width: 1200px-118px;
    .nav-wrap {
      position: absolute;
      top: 0;
      left: 0;
      &.fixed {
        position: fixed;
        right: 0;
        .nav-wrap-inner {
          width: 1200px;
        }
      }
    }
    .nav-wrap-inner {
      position: relative;
      margin: 0 auto;
    }
    .nav {
      position: absolute;
      left: 0;
      top: 0;
      width: 140px;
      height: 400px;
      // background-color: pink;
      border-right: 1px solid #eef1f7;
      padding-top: 60px;
      box-sizing: border-box;
      background-color: #fff;
      div {
        width: 100%;
        height: 32px;
        background-color: white;
        line-height: 32px;
        margin-bottom: 30px;
        font-weight: 600;
        color: #000;
        a {
          text-decoration: none;
          color: #000;
        }
        /*正常的未被访问过的链接*/
        a:link {
          text-decoration: none;
        }
        /*已经访问过的链接*/
        a:visited {
          text-decoration: none;
        }
        /*鼠标划过(停留)的链接*/
        a:hover {
          text-decoration: none;
          color: #26c9a5;
        }
        /* 正在点击的链接*/
        a:active {
          text-decoration: none;
        }
      }
      div:hover {
        color: #26c9a5;
        box-shadow: -4px 0 0 #26c9a5 inset;
      }
      .active {
        color: #26c9a5;
        box-shadow: -4px 0 0 #26c9a5 inset;
        a {
          color: #26c9a5;
        }
      }
    }
    .content {
      width: 100%;
      padding: 60px 0 0 50px;
      // background-color: skyblue;
    }
  }
}
</style>

